/**
 * The event.key values corresponding to each keyboard control
 *
 * Useful tool to get the keys: https://www.toptal.com/developers/keycode
 * @internal
 */
export const enum KeyboardControls {
  LEFT_ARROW = 'ArrowLeft',
  RIGHT_ARROW = 'ArrowRight',
  UP_ARROW = 'ArrowUp',
  DOWN_ARROW = 'ArrowDown',
  ENTER = 'Enter',
  ESCAPE = 'Escape',
  CMD = 'Meta',
  CONTROL = 'Control',
  ALT = 'Alt',
  SPACE = ' ',
  KEYBOARD_EXPLORE_MODE_SHORTCUT = 'e',
  KEYBOARD_EXPLORE_MODE_SHORTCUT_ALTERNATIVE = 'E',
  KEYBOARD_PAN_MODE_SHORTCUT = 'p',
  KEYBOARD_PAN_MODE_SHORTCUT_ALTERNATIVE = 'P',
  KEYBOARD_ZOOM_MODE_SHORTCUT = 'z',
  KEYBOARD_ZOOM_MODE_SHORTCUT_ALTERNATIVE = 'Z',
  KEYBOARD_RESET_SHORTCUT = 'r',
  KEYBOARD_RESET_SHORTCUT_ALTERNATIVE = 'R',
}

export const MIN_ZOOM_STEP = 10;
export const ZOOM_FACTOR = 0.1; // 10%
export const SMALL_STEP_FACTOR = 0.01; // 1%
export const LARGE_STEP_FACTOR = 0.02; // 2%

export const SELECTION_EDGE_THRESHOLD = 2; // 2px
export const SELECTION_RIGHT_OVERFLOW = 1;
